import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpBackend, HttpClient } from "@angular/common/http";
import * as jose from 'jose'; 

@Injectable({
  providedIn: 'root'
})
export class AzureTokenService {

  private httpClient: HttpClient;
  constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
    
  }

  getAzureTokenData() {
    var azureClientID = environment.billingProps.aud;
    const azureToken: any =
    JSON.parse(
      localStorage.getItem(
        JSON.parse(
          localStorage.getItem(
            `msal.token.keys.${azureClientID}`
          ) ?? ""
        ).accessToken[0]
      ) ?? ""
    )?.secret ?? "";

    return jose.decodeJwt(azureToken);
  }

}
